/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { JobCategoriesDto } from '../../models/job-categories-dto';

export interface GetJobCategories$Params {}

export function getJobCategories(
  http: HttpClient,
  rootUrl: string,
  params?: GetJobCategories$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<JobCategoriesDto>> {
  const rb = new RequestBuilder(rootUrl, getJobCategories.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JobCategoriesDto>;
      }),
    );
}

getJobCategories.PATH = '/auth/jobCategories';
